"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SKILL_BYTES = exports.MAX_SKILL_PATH_LENGTH = exports.MAX_SKILL_FILES = exports.SKILL_PRODUCTION_LABEL = exports.SKILL_LATEST_LABEL = void 0;
exports.SKILL_LATEST_LABEL = "latest";
exports.SKILL_PRODUCTION_LABEL = "production";
exports.MAX_SKILL_FILES = 200;
exports.MAX_SKILL_PATH_LENGTH = 512;
exports.MAX_SKILL_BYTES = 1_000_000;
